// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Golos;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  min-height: 100vh;
  overflow-x: hidden;
}

.container-fluid {
  margin: 1em auto;
  padding: 0;
}

.container-fluid a {
    font-family: Golos UI;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #192033;
  }

.container-fluid .content-info {
    margin-top: 5%;
    margin-left: 5%;
    margin-right: 5%;
  }

.container-fluid .content-info h1 {
    font-family: Golos;
    font-style: normal;
    font-weight: 600;
    font-size: 70px;
    line-height: 64px;
    color: #192033;
  }

.container-fluid .content-info p {
    font-family: Golos;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    color: #34373e;
  }

.container-fluid .content-info .button-info {
    width: 100%;
    height: auto;
    margin-top: 1em;
    background: rgba(255, 255, 255, 0.4);
    border: 1px solid #45454f;
    padding: 0.8em 0;
    border-radius: 8px;
  }

.container-fluid .content-info .button-map {
    width: 100%;
    height: auto;
    padding: 0.8em 0;
    background: #0055ff;
    border-radius: 8px;
  }

.container-fluid .button-map-outline {
    height: auto;
    padding: 0.8em 5em;
    background: #0055ff1a;
    border: none;
    color: #0055ff;
    border-radius: 8px;
  }

.container-fluid .landing-go-to-map > .ant-btn:hover {
      color: #ffffff;
      background-color: #6387ff;
    }

.container-fluid .button-map:hover {
    background: #6387ff;
  }

.container-fluid .button-info:hover {
    color: #6387ff;
    border-color: #6387ff;
  }

.container-fluid .content {
    margin: 0 5%;
    justify-content: space-between;
  }

.container-fluid .content-title {
    font-family: Golos;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 64px;
    margin-bottom: 64px;
  }

.container-fluid .content-main-text {
    font-family: Golos;
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    line-height: 44px;
    color: #34373e;
    margin-bottom: 0.5em;
  }

.container-fluid .content-text {
    font-family: Golos;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #34373e;
    margin-bottom: 1.5em;
  }

.container-fluid .feedback-title {
    font-family: Golos;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 56px;
  }

.container-fluid .feedback-second-title {
    font-size: 32px;
    line-height: 32px;
    margin-top: 0;
    font-weight: 500;
  }

.container-fluid .feedback-button {
    width: 315px;
    margin: 10px 0px;
    height: auto;
    padding: 0.8em 0;
    background: #0055ff;
    border-radius: 8px;
  }

.container-fluid .feedback-button:hover {
    background: #5179ff;
  }

.container-fluid .feedback-text {
    font-family: Golos;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 40px;
    color: #34373e;
    margin-bottom: 3em;
  }

.container-fluid .feedback-text .feedback-link {
      font-family: Golos;
      text-transform: none;
      font-size: 24px;
      line-height: 40px;
      letter-spacing: normal;
      color: #1890ff;
    }

.container-fluid .feedback-text .feedback-link:hover {
        color: #40a9ff;
      }

.container-fluid .content-sections {
    margin: 8em 4em 10em 4em;
  }

.container-fluid .content-sections .section-item {
      box-shadow: 0px 0px 8px 0px #0000001a;
      border-radius: 12px;
      padding: 1.5em;
      height: 180px;
      cursor: pointer;
    }

.container-fluid .content-sections .section-text {
      font-size: 22px;
      line-height: 26px;
      font-weight: 500;
    }

.container-fluid .content-sections div.section-icon-img {
      background-color: #91919e;
    }

.container-fluid .content-sections .section-icon-img {
      -o-object-fit: contain;
         object-fit: contain;
      margin-bottom: 2em;
      height: 40px;
      width: 40px;
    }

.container-fluid .feedback-button span,
  .container-fluid .button-map span,
  .container-fluid .button-info span {
    font-family: Golos UI;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

.page-block {
  margin-top: 10em;
}

.ant-layout {
  background: #ffffff !important;
}

/* container title */
.container-title {
  text-align: center;
  position: relative;
  padding: 0 0 20px;
  margin: 0 0 40px;
}

.container-title:after {
  transform: translateX(-50%);
  content: '';
  background: #1890ff;
  position: absolute;
  bottom: 0;
  left: 50%;
  height: 3px;
  width: 50px;
}

.container-title h2 {
  font-size: 28px;
  margin: 0;
}

/* header */
.main-block .app-header {
    background: transparent;
    line-height: 1.6;
  }

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px 15px 0px;
}

@media (orientation: portrait) {
  .main-block {
    height: 44vh;
  }
}

@media (orientation: landscape) {
  .main-block {
    height: 130vh;
  }

  @media (aspect-ratio: 16/9) {
    .main-block {
      height: 130vh;
    }

    @media (min-height: 769px) and (max-height: 1080px) {
      .main-block {
        height: 110vh;
      }
    }

    @media (min-height: 1440px) {
      .main-block {
        height: 110vh;
      }
    }

    @media (min-height: 2160px) {
      .main-block {
        height: 100vh;
      }
    }
  }
}

@media (aspect-ratio: 16/10) {
  .main-block {
    height: 100vh;
  }
}

@media (max-height: 600px) {
  .main-block {
    height: 768px;
  }
}

.main-block .container-fluid {
  display: block !important;
}

.main-block .content,
.main-block .content-info {
  justify-content: space-between;
  padding: 0 0 40px;
}

.main-block h3 {
  font-size: 30px;
  line-height: 1.2;
  margin: 0 0 30px;
}

.main-block p {
  margin: 0 0 15px;
}

.main-block .button-container {
  height: auto !important;
}

/* footer */
.ant-layout-footer {
  background: #34373e !important;
  color: #ffffff !important;
  text-align: center;
}

.landing-footer .landing-go-top {
    height: 40px;
    background: #ffffff;
    text-transform: uppercase;
    margin: 0 0 20px;
    color: #5179ff;
    border: 1px solid #5179ff;
    box-sizing: border-box;
    border-radius: 50px;
    padding: 7px;
    cursor: pointer;
    bottom: 50px !important;
  }

.landing-footer .landing-go-top:hover {
    background: #edf1ff;
    cursor: pointer;
  }

.landing-footer a {
    text-decoration: underline;
    text-transform: none;
    color: #ffffff;
  }
`, "",{"version":3,"sources":["webpack://./assets/scss/home.scss"],"names":[],"mappings":"AAEA;EACE,kBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AA0MZ;;AAzME;IACE,qBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAoB;EACtB;;AAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAoB;EACtB;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAqB;EACvB;;AAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,yBAAkC;IAClC,gBAAgB;IAChB,kBAAkB;EACpB;;AAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAA2B;IAC3B,kBAAkB;EACpB;;AAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAiC;IACjC,YAAY;IACZ,cAAsB;IACtB,kBAAkB;EACpB;;AAGE;MACE,cAAa;MACb,yBAA+B;IACjC;;AAGF;IACE,mBAAyB;EAC3B;;AAEA;IACE,cAAoB;IACpB,qBAA2B;EAC7B;;AAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAqB;IACrB,oBAAoB;EACtB;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAqB;IACrB,oBAAoB;EACtB;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAA2B;IAC3B,kBAAkB;EACpB;;AAEA;IACE,mBAAyB;EAC3B;;AAEA;IACE,kBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAqB;IACrB,kBAAkB;EAcpB;;AAZE;MACE,kBAAuB;MACvB,oBAAoB;MACpB,eAAe;MACf,iBAAiB;MACjB,sBAAsB;MACtB,cAAY;IAKd;;AAHE;QACE,cAAmB;MACrB;;AAIJ;IACE,wBAAwB;EA0B1B;;AAxBE;MACE,qCAAqC;MACrC,mBAAmB;MACnB,cAAc;MACd,aAAa;MACb,eAAe;IACjB;;AAEA;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAClB;;AAEA;MACE,yBAAiC;IACnC;;AAEA;MACE,sBAAmB;SAAnB,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,WAAW;IACb;;AAGF;;;IAGE,qBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,mBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,WAAW;AAET;IACE,uBAAwB;IACxB,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE;QACE,aAAa;MACf;IACF;;IAEA;MACE;QACE,aAAa;MACf;IACF;;IAEA;MACE;QACE,aAAa;MACf;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,8BAAqC;EACrC,yBAAwB;EACxB,kBAAkB;AACpB;;AAGE;IACE,YAAY;IACZ,mBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAoB;IACpB,yBAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;;AAEA;IACE,mBAAiC;IACjC,eAAe;EACjB;;AAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,cAAa;EACf","sourcesContent":["@import 'variables.scss';\n\nbody {\n  font-family: $font-main;\n  font-size: 16px;\n  line-height: 1.6;\n  color: $black-text;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.container-fluid {\n  margin: 1em auto;\n  padding: 0;\n  a {\n    font-family: $font-button;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: $black-accent;\n  }\n\n  .content-info {\n    margin-top: 5%;\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n\n  .content-info h1 {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 70px;\n    line-height: 64px;\n    color: $black-accent;\n  }\n\n  .content-info p {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 32px;\n    color: $black-primary;\n  }\n\n  .content-info .button-info {\n    width: 100%;\n    height: auto;\n    margin-top: 1em;\n    background: rgba(255, 255, 255, 0.4);\n    border: 1px solid $black-secondary;\n    padding: 0.8em 0;\n    border-radius: 8px;\n  }\n\n  .content-info .button-map {\n    width: 100%;\n    height: auto;\n    padding: 0.8em 0;\n    background: $accent-default;\n    border-radius: 8px;\n  }\n\n  .button-map-outline {\n    height: auto;\n    padding: 0.8em 5em;\n    background: $accent-default-light;\n    border: none;\n    color: $accent-default;\n    border-radius: 8px;\n  }\n\n  .landing-go-to-map {\n    & > .ant-btn:hover {\n      color: $white;\n      background-color: $blue-hovered;\n    }\n  }\n\n  .button-map:hover {\n    background: $blue-hovered;\n  }\n\n  .button-info:hover {\n    color: $blue-hovered;\n    border-color: $blue-hovered;\n  }\n\n  .content {\n    margin: 0 5%;\n    justify-content: space-between;\n  }\n\n  .content-title {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 48px;\n    line-height: 64px;\n    margin-bottom: 64px;\n  }\n\n  .content-main-text {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 36px;\n    line-height: 44px;\n    color: $black-primary;\n    margin-bottom: 0.5em;\n  }\n\n  .content-text {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: $black-primary;\n    margin-bottom: 1.5em;\n  }\n\n  .feedback-title {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 48px;\n    line-height: 56px;\n  }\n\n  .feedback-second-title {\n    font-size: 32px;\n    line-height: 32px;\n    margin-top: 0;\n    font-weight: 500;\n  }\n\n  .feedback-button {\n    width: 315px;\n    margin: 10px 0px;\n    height: auto;\n    padding: 0.8em 0;\n    background: $accent-default;\n    border-radius: 8px;\n  }\n\n  .feedback-button:hover {\n    background: $blue-default;\n  }\n\n  .feedback-text {\n    font-family: $font-main;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 40px;\n    color: $black-primary;\n    margin-bottom: 3em;\n\n    .feedback-link {\n      font-family: $font-main;\n      text-transform: none;\n      font-size: 24px;\n      line-height: 40px;\n      letter-spacing: normal;\n      color: $blue;\n\n      &:hover {\n        color: $blue-active;\n      }\n    }\n  }\n\n  .content-sections {\n    margin: 8em 4em 10em 4em;\n\n    .section-item {\n      box-shadow: 0px 0px 8px 0px #0000001a;\n      border-radius: 12px;\n      padding: 1.5em;\n      height: 180px;\n      cursor: pointer;\n    }\n\n    .section-text {\n      font-size: 22px;\n      line-height: 26px;\n      font-weight: 500;\n    }\n\n    div.section-icon-img {\n      background-color: $black-disabled;\n    }\n\n    .section-icon-img {\n      object-fit: contain;\n      margin-bottom: 2em;\n      height: 40px;\n      width: 40px;\n    }\n  }\n\n  .feedback-button span,\n  .button-map span,\n  .button-info span {\n    font-family: $font-button;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n\n.page-block {\n  margin-top: 10em;\n}\n\n.ant-layout {\n  background: $white !important;\n}\n\n/* container title */\n.container-title {\n  text-align: center;\n  position: relative;\n  padding: 0 0 20px;\n  margin: 0 0 40px;\n}\n\n.container-title:after {\n  transform: translateX(-50%);\n  content: '';\n  background: $blue;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  height: 3px;\n  width: 50px;\n}\n\n.container-title h2 {\n  font-size: 28px;\n  margin: 0;\n}\n\n/* header */\n.main-block {\n  .app-header {\n    background: $transparent;\n    line-height: 1.6;\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0px 15px 0px;\n}\n\n@media (orientation: portrait) {\n  .main-block {\n    height: 44vh;\n  }\n}\n\n@media (orientation: landscape) {\n  .main-block {\n    height: 130vh;\n  }\n\n  @media (aspect-ratio: 16/9) {\n    .main-block {\n      height: 130vh;\n    }\n\n    @media (min-height: 769px) and (max-height: 1080px) {\n      .main-block {\n        height: 110vh;\n      }\n    }\n\n    @media (min-height: 1440px) {\n      .main-block {\n        height: 110vh;\n      }\n    }\n\n    @media (min-height: 2160px) {\n      .main-block {\n        height: 100vh;\n      }\n    }\n  }\n}\n\n@media (aspect-ratio: 16/10) {\n  .main-block {\n    height: 100vh;\n  }\n}\n\n@media (max-height: 600px) {\n  .main-block {\n    height: $min_ipad_width;\n  }\n}\n\n.main-block .container-fluid {\n  display: block !important;\n}\n\n.main-block .content,\n.main-block .content-info {\n  justify-content: space-between;\n  padding: 0 0 40px;\n}\n\n.main-block h3 {\n  font-size: 30px;\n  line-height: 1.2;\n  margin: 0 0 30px;\n}\n\n.main-block p {\n  margin: 0 0 15px;\n}\n\n.main-block .button-container {\n  height: auto !important;\n}\n\n/* footer */\n.ant-layout-footer {\n  background: $black-primary !important;\n  color: $white !important;\n  text-align: center;\n}\n\n.landing-footer {\n  & .landing-go-top {\n    height: 40px;\n    background: $white;\n    text-transform: uppercase;\n    margin: 0 0 20px;\n    color: $blue-default;\n    border: 1px solid $blue-default;\n    box-sizing: border-box;\n    border-radius: 50px;\n    padding: 7px;\n    cursor: pointer;\n    bottom: 50px !important;\n  }\n\n  & .landing-go-top:hover {\n    background: $highlight-light-blue;\n    cursor: pointer;\n  }\n\n  & a {\n    text-decoration: underline;\n    text-transform: none;\n    color: $white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
